import 'css-chunksrc/client/scenes/calendar/week/unavailability/styles.scss';export default {
  "unavailability": "_unavailability_1k6k6_1",
  "background": "_background_1k6k6_8",
  "main": "_main_1k6k6_18",
  "icon": "_icon_1k6k6_30",
  "name": "_name_1k6k6_36"
};